import { render, staticRenderFns } from "./ModalBlock.vue?vue&type=template&id=f593a87c"
import script from "./ModalBlock.vue?vue&type=script&lang=js"
export * from "./ModalBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports